import * as Yup from 'yup';
export const initialSiteAddressValues = {
    name: '',
    addressLine1: '',
    addressLine2: '',
    addressLine3: '',
    postalCode: '',
    ward: '',
    provinceId: '',
};
export const siteAddressSchema = Yup.object().shape({
    name: Yup.string(),
    addressLine1: Yup.string(),
    addressLine2: Yup.string(),
    addressLine3: Yup.string(),
    postalCode: Yup.string(),
    ward: Yup.string(),
    provinceId: Yup.string(),
});
//# sourceMappingURL=site-address.js.map